import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getList() {
    return axiosIns.get('/admin/report_formula_items')
  },
  create(params) {
    return axiosIns.post('/admin/report_formula_items', { report_formula_item: snakecaseKeys(params) })
  },
  update(id, params) {
    return axiosIns.patch(`/admin/report_formula_items/${id}`, { report_formula_item: snakecaseKeys(params) })
  },
  destroy(id) {
    return axiosIns.delete(`/admin/report_formula_items/${id}`)
  },
  updatePositions(params) {
    return axiosIns.patch('/admin/report_formula_items/update_positions', snakecaseKeys(params))
  },
}
